import { Menu } from '@mantine/core';
import classnames from 'classnames';

import styles from './DrowdownMenuItem.module.scss';
import { Props } from './DrowdownMenuItem.types';

const DrowdownMenuItem = ({ label, icon, onClick, selected }: Props) => {
  const Icon = icon;
  return (
    <Menu.Item
      className={classnames(styles.container, { [styles.selected]: selected })}
      onClick={onClick}
    >
      {Icon && <div className={styles.icon}>{Icon}</div>}
      <p className={classnames(styles.label, { [styles.labelSelected]: selected })}>{label}</p>
    </Menu.Item>
  );
};

export default DrowdownMenuItem;
